import useWindowDimensions from "react-native-web/dist/cjs/exports/useWindowDimensions";
export function useIsMobile() {
  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  return width < 992;
}